import React, { useEffect } from "react";
//importing components
import Navbar from "./Navbar";
import HeroSection from "./HeroSection";

function AboveTheFold(props) {
  return (
    <div>
      <Navbar></Navbar>
      <HeroSection hideScroller={props.hideScroller}></HeroSection>
    </div>
  );
}
export default AboveTheFold;
